var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchaseTips"},[_c('p',[_vm._v(" 亲爱的学员，您还未完成购买，无法参与此课程"),_c('br'),_vm._v(" 请点击此处 "),_vm._t("purchase")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }